import MDTextInput from "./Inputs/MDTextInput";
import MDPhoneInput from "./Inputs/MDPhoneInput";
import MDSelectInput from "./Inputs/MDSelect";
import { multiFormCategory } from "../utils/enum";

const FormFirstSlide = (props) => {
  const {
    values,
    errors,
    submitCount,
    handleChange,
    handleBlur,
    isMultiPartForm,
    isPropTForm = false,
  } = props;

  return (
    <div className="d-flex flex-column gap-3">
      <MDTextInput
        label="Enter your Name"
        name="name"
        value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        error={submitCount > 0 && Boolean(errors.name)}
        helperText={submitCount > 0 && errors.name}
        fullWidth
      />
      <MDTextInput
        label="Enter your Email"
        name="email"
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        error={submitCount > 0 && Boolean(errors.email)}
        helperText={submitCount > 0 && errors.email}
        fullWidth
      />
      <MDPhoneInput
        name="phone"
        value={values.phone}
        onChange={handleChange}
        onBlur={handleBlur}
        error={submitCount > 0 && Boolean(errors.phone)}
        helperText={submitCount > 0 && errors.phone}
        fullWidth
      />

      {isMultiPartForm && !isPropTForm && (
        <div>
          <p className="label_heading">How can we help you with Real Estate?</p>
          <MDSelectInput
            label="Select"
            name="category"
            value={values.category}
            options={multiFormCategory}
            onChange={handleChange}
            onBlur={handleBlur}
            error={submitCount > 0 && Boolean(errors.category)}
            helperText={submitCount > 0 && errors.category}
            fullWidth
          />
        </div>
      )}

      <p className="policy_text m-0">
        {`By clicking the below buttons, I agree to receive marketing and customer
        service calls and text messages from our ${
          isPropTForm ? "PropTdeals" : "brokerage"
        }. Consent is not a
        condition of purchase. Msg/data rates may apply. Msg frequency varies.
        Reply STOP to unsubscribe. Privacy Policy & Terms of Service.`}
      </p>
    </div>
  );
};

export default FormFirstSlide;
